import { RoutingConfig } from "@spartacus/core";

export const genRoutingConfig: RoutingConfig = {
  routing: {
    routes: {
      login: { paths: ['login'], protected: false, authFlow: true },
      loginForm: { paths: ['login'], protected: false, authFlow: true },
      bundles: { paths: ['bundles/:productCode/:name'] },
      search: { paths: ['search/:query'] },
      checkoutLogin: { paths: ['checkout-login'], authFlow: true },
      checkout: { paths: ['checkout'] },
      checkoutSpecialHandling: { paths: ['checkout/special-handling'] },
      checkoutDeliveryAddress: { paths: ['checkout/delivery-address'] },
      checkoutFinishedGoods: { paths: ['checkout/finished-goods'] },
      checkoutServiceParts: { paths: ['checkout/service-parts'] },
      checkoutSubscriptionInfo: { paths: ['checkout/subscription-info'] },
      checkoutPaymentDetails: { paths: ['checkout/payment-details'] },
      checkoutReviewOrder: { paths: ['checkout/review-order'] },
      checkoutEngineReplacementForm: { paths: ['checkout/engine-replacement-attestation'] },
      termsAndConditions: { paths: ['terms-and-conditions'] },
      termsAndConditionsCheckout: { paths: ['terms-and-conditions-checkout'] },
      termsAndConditionsSubscription: { paths: ['terms-and-conditions-subscription'] },
      product: {
        paths: ['product/:productCode/:name', 'product/:productCode'],
        paramsMapping: { name: 'slug' },
      },
    }
  }
}